import {
  setItemLoading,
  setItemSuccess,
  setItemError,
  setItemsLoading,
  setItemsSuccess,
  setItemsError,
  deleteListItemLoading,
  deleteListItemSuccess,
  deleteListItemFail,
} from "../../reducers/Store/item";

export const setItem = (item) => async (dispatch) => {
  try {
    dispatch(setItemLoading());
    dispatch(setItemSuccess(item));
  } catch (error) {
    console.error(error);
    dispatch(setItemError("Failed to set list item"));
  }
};
export const setItems = (item) => async (dispatch) => {
  try {
    dispatch(setItemsLoading());
    dispatch(setItemsSuccess(item));
  } catch (error) {
    console.error(error);
    dispatch(setItemsError("Failed to set list items"));
  }
};

export const deleteListItem = (item_ean13) => async (dispatch) => {
  try {
    dispatch(deleteListItemLoading());
    dispatch(deleteListItemSuccess(item_ean13));
  } catch (error) {
    console.error(error);
    dispatch(deleteListItemFail("Failed to delete list item"));
  }
};
